import { right } from "fp-ts/lib/Either";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";
import callAPI from "../../../fetchCallImplementation";

//TODO implement
const GetAISummaryByUserApiImpl = async (query: any, type: string, params: string): Promise<any> => {
    
    const channel = type === 'customer' ? 'calls' : type;
    let customerParam = `channel=${channel}`;
    let lobParam = '';
    let agentParam = '';
    let aiEvaluated = '';
    let manualEvaluated = '';
    let dateInit = '';
    let dateEnd = '';
    let status = '';
    let hrId = '';

    if (query.agent) {
        agentParam = `&user_id=${query.user_id}`
    }
    if (query.lob) {
        lobParam = `&lob=${query.lob}`
    }
    if (query.customer) {
        customerParam += `&customer=${query.customer}`;
    }
    if (query.aiEvaluated) {
        aiEvaluated = `&aiEvaluated=${query.aiEvaluated === "True" ? true : false}`
    }
    if (query.manualEvaluated) {
        manualEvaluated = `&manualEvaluated=${query.manualEvaluated === "True" ? true : false}`
    }
    if (query.dateInit) {
        dateInit = `&dateFrom=${query.dateInit}`
    }
    if (query.dateEnd) {
        dateEnd = `&dateTo=${query.dateEnd}`
    }
    if (query.status) {
        status = `&status=${query.status}`
    }
    if (query.hrId) {
        hrId = `&hrId=${query.hrId}`
    }
    let additionalParams = '';
    if (params && params !== "") {
        additionalParams = "&" + params;
    }
    
    const baseUrl = di.get<Constants>(ConstantsName).AI;

    // Build URL properly
    let url = baseUrl + `/list?${customerParam}${lobParam}${agentParam}${aiEvaluated}${manualEvaluated}${dateInit}${dateEnd}${status}${hrId}`;
    
    // Add limit if not already present in params
    if (!params || !params.includes('limit')) {
        url += `&limit=20`;
    }
    
    // Add additional parameters if they exist
    if (params && params !== "") {
        url += `&${params}`;
    }

    console.log('GetAISummaryByCustomerApiImpl - URL:', url);
    console.log('GetAISummaryByCustomerApiImpl - params:', params);

    const response = await callAPI(url, 'GET', {});

    const reader = response.body?.getReader();

    if (!reader) {
        throw new Error("Readable stream not supported or body is empty.");
    }
    
    let result = '';
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        result += decoder.decode(value, { stream: true });
    }

    // Decoding the last chunk
    result += decoder.decode();
    
    return right(result);
}

export default GetAISummaryByUserApiImpl;